// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2811":"93366c50","4044":"d7effc80","7360":"4e38013c","8692":"83c128ec","9738":"4e87aa37"}[chunkId] + ".chunk.css";
};